import { render, staticRenderFns } from "./Inventories_import.vue?vue&type=template&id=2165e059&"
import script from "./Inventories_import.vue?vue&type=script&lang=js&"
export * from "./Inventories_import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports